module.exports = __webpack_public_path__ + "img/report.ab74b381.svg";